import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la comparación en tiempo real",
    opening: localizedGenderNode(
      [
      "Hoy no lucho contra la comparación. Solo la noto cuando aparece."
    ],
      [
      "Hoy no lucho contra la comparación. Solo la noto cuando aparece."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esto es comparación. No es verdad.”",
      "Observo dónde está en el cuerpo — sin corregir. Solo observar."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "En mi interior: “Esto es comparación. No es verdad.”",
      "Observo dónde está en el cuerpo — sin corregir. Solo observar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuándo apareció hoy la comparación? (lugar/persona/redes)\n[Escribe aquí]",
      "2. ¿Qué comparé exactamente? (aspecto/dinero/éxito/relación/paz)\n[Escribe aquí]",
      "3. ¿Qué dijo la comparación sobre mí? (la frase exacta)\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuándo apareció hoy la comparación? (lugar/persona/redes)\n[Escribe aquí]",
      "2. ¿Qué comparé exactamente? (aspecto/dinero/éxito/relación/paz)\n[Escribe aquí]",
      "3. ¿Qué dijo la comparación sobre mí? (la frase exacta)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Hoy no creo cada frase que aparece. Solo la veo."
    ],
      [
      "Cierre:",
      "Hoy no creo cada frase que aparece. Solo la veo."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + “Vuelvo a mí”.",
      "Una vez hoy: una respiración + “Vuelvo a mí”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Hecho vs. interpretación (CBT suave)",
    opening: localizedGenderNode(
      [
      "Hoy separo los hechos del relato que mi mente construye."
    ],
      [
      "Hoy separo los hechos del relato que mi mente construye."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Un hecho no es una humillación.”",
      "Observo el pensamiento como una nube que pasa."
    ],
      [
      "Una respiración. “Un hecho no es una humillación.”",
      "Observo el pensamiento como una nube que pasa."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es el hecho que vi? (sin interpretación)\n[Escribe aquí]",
      "2. ¿Qué interpretación saltó de inmediato? (“Significa que yo…”)\n[Escribe aquí]",
      "3. ¿Qué interpretación alternativa, más suave, es posible?\n[Escribe aquí]",
      "4. ¿Qué pasa si me quedo solo con el hecho?\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es el hecho que vi? (sin interpretación)\n[Escribe aquí]",
      "2. ¿Qué interpretación saltó de inmediato? (“Significa que yo…”)\n[Escribe aquí]",
      "3. ¿Qué interpretación alternativa, más suave, es posible?\n[Escribe aquí]",
      "4. ¿Qué pasa si me quedo solo con el hecho?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Mi dolor es real — la historia no siempre es precisa."
    ],
      [
      "Cierre:",
      "Mi dolor es real — la historia no siempre es precisa."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Hecho ≠ interpretación” + respiración.",
      "Una vez hoy: “Hecho ≠ interpretación” + respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Mis disparadores principales",
    opening: localizedGenderNode(
      [
      "Hoy aprendo dónde le gusta aparecer la comparación."
    ],
      [
      "Hoy aprendo dónde le gusta aparecer la comparación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Si reconozco el disparador — tengo poder.”",
      "Observo pulso/pecho/abdomen — sin prisa."
    ],
      [
      "Una respiración. “Si reconozco el disparador — tengo poder.”",
      "Observo pulso/pecho/abdomen — sin prisa."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Mis 3 disparadores principales de comparación:\n[Escribe aquí]",
      "2. ¿Qué emoción hay debajo de la comparación? (vergüenza/miedo/inseguridad/soledad)\n[Escribe aquí]",
      "3. ¿Qué hago inmediatamente después del disparador? (me encojo/comparo más/evito/intento impresionar)\n[Escribe aquí]"
    ],
      [
      "1. Mis 3 disparadores principales de comparación:\n[Escribe aquí]",
      "2. ¿Qué emoción hay debajo de la comparación? (vergüenza/miedo/inseguridad/soledad)\n[Escribe aquí]",
      "3. ¿Qué hago inmediatamente después del disparador? (me encojo/comparo más/evito/intento impresionar)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "No estoy “roto/a”. Tengo un patrón."
    ],
      [
      "Cierre:",
      "No estoy “roto/a”. Tengo un patrón."
    ]
    ),
    action: localizedGenderNode(
      "Hoy elijo un disparador y practico una pausa de 10 segundos.",
      "Hoy elijo un disparador y practico una pausa de 10 segundos."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La comparación como protección",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que la comparación intenta protegerme de un modo torcido."
    ],
      [
      "Hoy entiendo que la comparación intenta protegerme de un modo torcido."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “La comparación es un intento de control.”",
      "Me pregunto: ¿qué intento no sentir?"
    ],
      [
      "Una respiración. “La comparación es un intento de control.”",
      "Me pregunto: ¿qué intento no sentir?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué intenta evitar que yo sienta la comparación?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si “me quedo atrás”?\n[Escribe aquí]",
      "3. ¿Qué parte de mí necesita seguridad ahora?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué intenta evitar que yo sienta la comparación?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si “me quedo atrás”?\n[Escribe aquí]",
      "3. ¿Qué parte de mí necesita seguridad ahora?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Cuando entiendo el mecanismo — se calma."
    ],
      [
      "Cierre:",
      "Cuando entiendo el mecanismo — se calma."
    ]
    ),
    action: localizedGenderNode(
      "Una frase: “Veo por qué haces esto. Gracias.” + respiración.",
      "Una frase: “Veo por qué haces esto. Gracias.” + respiración."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Devolver el valor a casa",
    opening: localizedGenderNode(
      [
      "Hoy llevo la medida de vuelta a mí — no al mundo."
    ],
      [
      "Hoy llevo la medida de vuelta a mí — no al mundo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Mi vida no es una competencia.”",
      "Observo algo bueno en mí ahora — aunque sea pequeño."
    ],
      [
      "Una respiración. “Mi vida no es una competencia.”",
      "Observo algo bueno en mí ahora — aunque sea pequeño."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿En qué área me siento “menos”?\n[Escribe aquí]",
      "2. ¿Qué cosa verdadera en mí no se mide allí?\n[Escribe aquí]",
      "3. ¿Qué valor elijo para medirme? (verdad/respeto/paz/crecimiento)\n[Escribe aquí]"
    ],
      [
      "1. ¿En qué área me siento “menos”?\n[Escribe aquí]",
      "2. ¿Qué cosa verdadera en mí no se mide allí?\n[Escribe aquí]",
      "3. ¿Qué valor elijo para medirme? (verdad/respeto/paz/crecimiento)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "El valor propio no se mide frente a otros. Se construye desde adentro."
    ],
      [
      "Cierre:",
      "El valor propio no se mide frente a otros. Se construye desde adentro."
    ]
    ),
    action: localizedGenderNode(
      "Escribo 3 valores/cualidades “solo míos” y los guardo.",
      "Escribo 3 valores/cualidades “solo míos” y los guardo."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Redes sociales: limpieza suave",
    opening: localizedGenderNode(
      [
      "Hoy reduzco la exposición que enciende la comparación."
    ],
      [
      "Hoy reduzco la exposición que enciende la comparación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No tengo que entrar al fuego.”",
      "Antes de abrir redes — una respiración y la pregunta: “¿Esto me hace bien ahora?”"
    ],
      [
      "Una respiración. “No tengo que entrar al fuego.”",
      "Antes de abrir redes — una respiración y la pregunta: “¿Esto me hace bien ahora?”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué tipo de contenido me activa más?\n[Escribe aquí]",
      "2. ¿Qué busco realmente allí? (aprobación/esperanza/escape/inspiración)\n[Escribe aquí]",
      "3. ¿Qué límite pequeño me protegerá esta semana?\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué tipo de contenido me activa más?\n[Escribe aquí]",
      "2. ¿Qué busco realmente allí? (aprobación/esperanza/escape/inspiración)\n[Escribe aquí]",
      "3. ¿Qué límite pequeño me protegerá esta semana?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "El límite es respeto propio."
    ],
      [
      "Cierre:",
      "El límite es respeto propio."
    ]
    ),
    action: localizedGenderNode(
      "Hoy elimino/silencio un disparador.",
      "Hoy elimino/silencio un disparador."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Convertir la comparación en información",
    opening: localizedGenderNode(
      [
      "Si comparo — quizá me muestre lo que quiero."
    ],
      [
      "Si comparo — quizá me muestre lo que quiero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “La comparación puede volverse brújula.”",
      "Observo la punzada y pregunto: ¿qué quiere contarme?"
    ],
      [
      "Una respiración. “La comparación puede volverse brújula.”",
      "Observo la punzada y pregunto: ¿qué quiere contarme?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién o con qué me comparé hoy?\n[Escribe aquí]",
      "2. ¿Qué revela que en realidad quiero?\n[Escribe aquí]",
      "3. ¿Cuál es un paso del 10% en esa dirección?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién o con qué me comparé hoy?\n[Escribe aquí]",
      "2. ¿Qué revela que en realidad quiero?\n[Escribe aquí]",
      "3. ¿Cuál es un paso del 10% en esa dirección?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Dejo de castigarme con la comparación — y empiezo a usarla bien."
    ],
      [
      "Cierre:",
      "Dejo de castigarme con la comparación — y empiezo a usarla bien."
    ]
    ),
    action: localizedGenderNode(
      "Un paso del 10% solamente.",
      "Un paso del 10% solamente."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Exposición suave (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy permito que la comparación esté aquí un minuto — sin actuar."
    ],
      [
      "Hoy permito que la comparación esté aquí un minuto — sin actuar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Es una ola.”",
      "Dejo que la sensación esté — solo respirar."
    ],
      [
      "Una respiración. “Es una ola.”",
      "Dejo que la sensación esté — solo respirar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál fue el disparador hoy?\n[Escribe aquí]",
      "2. ¿Qué pasó en mi cuerpo después de un minuto?\n[Escribe aquí]",
      "3. ¿Qué aprendí? (¿realmente “no pasa”?)\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál fue el disparador hoy?\n[Escribe aquí]",
      "2. ¿Qué pasó en mi cuerpo después de un minuto?\n[Escribe aquí]",
      "3. ¿Qué aprendí? (¿realmente “no pasa”?)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Me fortalezco porque me quedé."
    ],
      [
      "Cierre:",
      "Me fortalezco porque me quedé."
    ]
    ),
    action: localizedGenderNode(
      "Solo un minuto. Constancia > fuerza.",
      "Solo un minuto. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Vergüenza debajo de la comparación",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin dejar que me destruya."
    ],
      [
      "Hoy toco la vergüenza sin dejar que me destruya."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “La vergüenza es dolor, no verdad.”",
      "Mano en pecho/abdomen (si es cómodo) y una respiración."
    ],
      [
      "Una respiración. “La vergüenza es dolor, no verdad.”",
      "Mano en pecho/abdomen (si es cómodo) y una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Cuál es la frase de vergüenza?\n[Escribe aquí]",
      "2. ¿Qué le diría a un amigo querido con esa frase?\n[Escribe aquí]",
      "3. Una frase suave que puedo decirme hoy\n[Escribe aquí]"
    ],
      [
      "1. ¿Cuál es la frase de vergüenza?\n[Escribe aquí]",
      "2. ¿Qué le diría a un amigo querido con esa frase?\n[Escribe aquí]",
      "3. Una frase suave que puedo decirme hoy\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "La compasión sana más que la prueba."
    ],
      [
      "Cierre:",
      "La compasión sana más que la prueba."
    ]
    ),
    action: localizedGenderNode(
      "Una frase suave, una sola vez.",
      "Una frase suave, una sola vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Dejar de “ganar” para valer",
    opening: localizedGenderNode(
      [
      "Hoy veo el esfuerzo por ser “más” — y lo aflojo un poco."
    ],
      [
      "Hoy veo el esfuerzo por ser “más” — y lo aflojo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No necesito ganar para ser amado/a.”",
      "Observo dónde me encojo para impresionar."
    ],
      [
      "Una respiración. “No necesito ganar para ser amado/a.”",
      "Observo dónde me encojo para impresionar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Dónde intento demostrar que valgo?\n[Escribe aquí]",
      "2. ¿Cuál es el precio?\n[Escribe aquí]",
      "3. ¿Cómo se ve un “suficiente” pequeño hoy?\n[Escribe aquí]"
    ],
      [
      "1. ¿Dónde intento demostrar que valgo?\n[Escribe aquí]",
      "2. ¿Cuál es el precio?\n[Escribe aquí]",
      "3. ¿Cómo se ve un “suficiente” pequeño hoy?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Soy valioso/a incluso cuando simplemente soy yo."
    ],
      [
      "Cierre:",
      "Soy valioso/a incluso cuando simplemente soy yo."
    ]
    ),
    action: localizedGenderNode(
      "Hoy hago una cosa sin explicar ni probar.",
      "Hoy hago una cosa sin explicar ni probar."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Comparación dentro de las relaciones",
    opening: localizedGenderNode(
      [
      "Hoy noto cómo la comparación entra en los vínculos."
    ],
      [
      "Hoy noto cómo la comparación entra en los vínculos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No tengo que ser ‘más’ para quedarme.”",
      "Siento la necesidad de ser perfecto/a — y suelto una respiración."
    ],
      [
      "Una respiración. “No tengo que ser ‘más’ para quedarme.”",
      "Siento la necesidad de ser perfecto/a — y suelto una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Con quién me comparo en las relaciones?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si soy ‘menos’?\n[Escribe aquí]",
      "3. ¿Qué límite interno pequeño me ayudaría?\n[Escribe aquí]"
    ],
      [
      "1. ¿Con quién me comparo en las relaciones?\n[Escribe aquí]",
      "2. ¿Qué temo que pase si soy ‘menos’?\n[Escribe aquí]",
      "3. ¿Qué límite interno pequeño me ayudaría?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "El vínculo real no exige competencia."
    ],
      [
      "Cierre:",
      "El vínculo real no exige competencia."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Sigo siendo yo.” + respiración.",
      "Una vez hoy: “Sigo siendo yo.” + respiración."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Nuevo lenguaje interno",
    opening: localizedGenderNode(
      [
      "Hoy cambio una frase que me dirige."
    ],
      [
      "Hoy cambio una frase que me dirige."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Las palabras son un hogar.”",
      "Escucho las palabras en mi cabeza como música — se puede cambiar el tono."
    ],
      [
      "Una respiración. “Las palabras son un hogar.”",
      "Escucho las palabras en mi cabeza como música — se puede cambiar el tono."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Mi frase comparativa principal\n[Escribe aquí]",
      "2. Una versión humana y suave de esa frase\n[Escribe aquí]",
      "3. Una nueva frase que adopto para la semana\n[Escribe aquí]"
    ],
      [
      "1. Mi frase comparativa principal\n[Escribe aquí]",
      "2. Una versión humana y suave de esa frase\n[Escribe aquí]",
      "3. Una nueva frase que adopto para la semana\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "Cuando cambio una palabra — cambio de dirección."
    ],
      [
      "Cierre:",
      "Cuando cambio una palabra — cambio de dirección."
    ]
    ),
    action: localizedGenderNode(
      "Hoy uso la frase nueva una sola vez.",
      "Hoy uso la frase nueva una sola vez."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Construir identidad sin medición",
    opening: localizedGenderNode(
      [
      "Hoy construyo una identidad de avance, no de comparación."
    ],
      [
      "Hoy construyo una identidad de avance, no de comparación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Estoy en camino.”",
      "Me pregunto: ¿qué es importante para mí de verdad, sin relación con otros?"
    ],
      [
      "Una respiración. “Estoy en camino.”",
      "Me pregunto: ¿qué es importante para mí de verdad, sin relación con otros?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Un valor que elijo para guiarme\n[Escribe aquí]",
      "2. Un hábito pequeño que sirva ese valor esta semana\n[Escribe aquí]",
      "3. Una promesa para mí en días de comparación fuerte\n[Escribe aquí]"
    ],
      [
      "1. Un valor que elijo para guiarme\n[Escribe aquí]",
      "2. Un hábito pequeño que sirva ese valor esta semana\n[Escribe aquí]",
      "3. Una promesa para mí en días de comparación fuerte\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre:",
      "No soy competencia. Soy un camino."
    ],
      [
      "Cierre:",
      "No soy competencia. Soy un camino."
    ]
    ),
    action: localizedGenderNode(
      "Planifico una acción pequeña para la semana que me devuelva estabilidad.",
      "Planifico una acción pequeña para la semana que me devuelva estabilidad."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave: volver a casa",
    opening: localizedGenderNode(
      [
      "Hoy cierro un capítulo sin ganar. Vuelvo a casa."
    ],
      [
      "Hoy cierro un capítulo sin ganar. Vuelvo a casa."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Estoy de mi lado.”",
      "Siento el suelo debajo de mí. Estoy aquí."
    ],
      [
      "Una respiración. “Estoy de mi lado.”",
      "Siento el suelo debajo de mí. Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ¿Qué cambió en mí en este recorrido? (3 cosas)\n[Escribe aquí]",
      "2. ¿Qué me queda más claro sobre la comparación?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles (corta, en el bolsillo):\n[Escribe aquí]"
    ],
      [
      "1. ¿Qué cambió en mí en este recorrido? (3 cosas)\n[Escribe aquí]",
      "2. ¿Qué me queda más claro sobre la comparación?\n[Escribe aquí]",
      "3. Frase de regreso para días difíciles (corta, en el bolsillo):\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final:",
      "No borro la comparación.",
      "Simplemente dejo de permitir que me dirija.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final:",
      "No borro la comparación.",
      "Simplemente dejo de permitir que me dirija.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice “vuelvo a mí”: caminar / escribir 5 líneas / una limpieza pequeña / hablar con una persona segura.",
      "Una acción que simbolice “vuelvo a mí”: caminar / escribir 5 líneas / una limpieza pequeña / hablar con una persona segura."
    ),
  },
].map(buildNormalizedDay);

export const constantComparisonToOthersBlueprintEs = buildNormalizedPilotBlueprint({
  id: "constant_comparison_to_others_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "constant_comparison_to_others",
  category: "general",
  journeyName: {
    he: "השוואה תמידית לאחרים",
    en: "Constant Comparison to Others",
    es: "Comparación constante con los demás",
  },
  days,
});

export default constantComparisonToOthersBlueprintEs;
